import React, { useCallback } from 'react'
import UserSettingsLayerLib, { UserSettings, userSettingsCookieName } from '@web/walter-lib/user-settings'
import { useCookies } from '@web/walter-lib/cookies'
import { cookieOptions } from '~constants/cookies'

interface Props {
    children: React.ReactNode
}

/**
 * UserSettingsLayer
 */
function UserSettingsLayer(props: Props) {
    const cookies = useCookies()

    const onSetUserSettings = useCallback(
        (settings: UserSettings) => {
            cookies?.set(userSettingsCookieName, settings, cookieOptions)
        },
        [cookies]
    )

    return (
        <UserSettingsLayerLib initialState={cookies?.get(userSettingsCookieName)} onSetUserSettings={onSetUserSettings}>
            {props.children}
        </UserSettingsLayerLib>
    )
}

export default UserSettingsLayer
